import React from "react";

export default function PrivacyPolicy() {
  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        maxWidth: "1000px",
        margin: "0 auto",
        padding: "30px",
        lineHeight: "1.6",
        color: "#333",
      }}
    >
      <h1
        style={{
          color: "#1a5276",
          textAlign: "center",
          marginBottom: "40px",
          fontSize: "32px",
        }}
      >
        Privacy Policy for Bombay Dental Company
      </h1>

      <div
        style={{
          background: "#f8f9fa",
          padding: "25px",
          borderRadius: "8px",
          marginBottom: "30px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        }}
      >
        <h2 style={{ color: "#2874a6", marginBottom: "15px" }}>Introduction</h2>
        <p>
          Bombay Dental Company ("we", "our", "us") is committed to protecting
          and respecting your privacy. This Privacy Policy explains how we
          collect, use, disclose, and safeguard your information when you visit
          our website [insert website URL], or when you engage with us through
          our online services. Please read this privacy policy carefully to
          understand our views and practices regarding your personal data.
        </p>

        <p>
          By using our website, you agree to the collection and use of your data
          in accordance with this policy.
        </p>
      </div>

      <div
        style={{
          background: "#f8f9fa",
          padding: "25px",
          borderRadius: "8px",
          marginBottom: "30px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        }}
      >
        <h2 style={{ color: "#2874a6", marginBottom: "15px" }}>
          Information We Collect
        </h2>
        <p>
          We collect the following types of information when you visit or use
          our website:
        </p>
        <h3>Personal Information</h3>
        <p>
          When you visit our website or interact with us, you may be asked to
          provide personal information, including but not limited to:
        </p>
        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Postal address</li>
          <li>Medical information (if relevant to services provided)</li>
        </ul>
        <h3>Non-Personal Information:</h3>
        <p>We may also collect non-personal information such as:</p>
        <ul>
          <li>Browser type and version</li>
          <li>IP address</li>
          <li>Device type</li>
          <li>Operating system</li>
          <li>Referral URLs</li>
          <li>Pages visited on our site</li>
          <li>Time spent on our site</li>
        </ul>
      </div>

      <div
        style={{
          background: "#f8f9fa",
          padding: "25px",
          borderRadius: "8px",
          marginBottom: "30px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        }}
      >
        <h2 style={{ color: "#2874a6", marginBottom: "15px" }}>
          How We Use Your Information
        </h2>
        <p>We use the information we collect for the following purposes:</p>
        <ul>
          <li> To provide dental services and support </li>
          <li> To respond to inquiries or requests </li>
          <li> To improve the user experience on our website </li>
          <li>
            {" "}
            To communicate with you about our services, promotions, or updates{" "}
          </li>
          <li> To comply with legal obligations and industry regulations </li>
          <li>
            {" "}
            To enhance security and monitor the functionality of our website
          </li>
        </ul>
      </div>
      <div
        style={{
          background: "#f8f9fa",
          padding: "25px",
          borderRadius: "8px",
          marginBottom: "30px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        }}
      >
        <h2 style={{ color: "#2874a6", marginBottom: "15px" }}>Cookies</h2>
        <p>
          Our website may use cookies and similar technologies to improve your
          experience and gather data about how our site is used. Cookies are
          small text files placed on your device to remember preferences and
          activities.
        </p>
        <p>
          You can control the use of cookies through your browser settings.
          Please note that disabling cookies may affect the functionality of our
          website.
        </p>
      </div>

      <div
        style={{
          background: "#f8f9fa",
          padding: "25px",
          borderRadius: "8px",
          marginBottom: "30px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        }}
      >
        <h2 style={{ color: "#2874a6", marginBottom: "15px" }}>
          Data Sharing and Disclosure
        </h2>
        <p>
          We do not sell or rent your personal information to third parties.
          However, we may share your personal information with third parties in
          the following cases:
        </p>
        <ul>
          <li>
            <strong> Service Providers:</strong> We may share your information
            with trusted service providers who assist us in operating our
            website, conducting business, or providing services to you, such as
            payment processors, email providers, or hosting services.
          </li>
          <li>
            <strong> Legal Requirements:</strong> We may disclose your
            information when required by law or to comply with a legal process,
            such as a court order or government request
          </li>
          <li>
            <strong> Business Transfers:</strong> In the event of a merger,
            acquisition, or sale of assets, your personal information may be
            transferred as part of the transaction..
          </li>
        </ul>
      </div>

      <div
        style={{
          background: "#f8f9fa",
          padding: "25px",
          borderRadius: "8px",
          marginBottom: "30px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        }}
      >
        <h2 style={{ color: "#2874a6", marginBottom: "15px" }}>
          Security of Your Information
        </h2>
        <p>
          We implement appropriate technical and organizational measures to
          protect your personal information from unauthorized access,
          alteration, disclosure, or destruction. While we strive to use
          commercially acceptable means to protect your information, no method
          of transmission over the internet or electronic storage is 100%
          secure. We cannot guarantee the absolute security of your data.
        </p>
      </div>
      <div
        style={{
          background: "#f8f9fa",
          padding: "25px",
          borderRadius: "8px",
          marginBottom: "30px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        }}
      >
        <h2 style={{ color: "#2874a6", marginBottom: "15px" }}>
          Data Retention
        </h2>
        <p>
          We will retain your personal information only for as long as necessary
          to fulfill the purposes outlined in this Privacy Policy or as required
          by law.
        </p>
      </div>
      <div
        style={{
          background: "#f8f9fa",
          padding: "25px",
          borderRadius: "8px",
          marginBottom: "30px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        }}
      >
        <h2 style={{ color: "#2874a6", marginBottom: "15px" }}>
          Your Rights and Choices
        </h2>
        <p>
          You have certain rights regarding your personal information,
          including:
        </p>
        <ul>
          <li>
            <strong>Access and Correction:</strong> You may request access to
            your personal data and request corrections if the information is
            inaccurate or incomplete.
          </li>
          <li>
            <strong>Deletion:</strong> You may request that we delete your
            personal information, subject to applicable legal requirements.
          </li>
          <li>
            <strong>Opt-Out:</strong> You can opt out of receiving marketing
            communications by following the unsubscribe instructions in our
            emails or by contacting us directly.
          </li>
        </ul>
        <p>
          To exercise any of these rights, please contact us using the contact
          information provided below.
        </p>
      </div>

      <div
        style={{
          background: "#f8f9fa",
          padding: "25px",
          borderRadius: "8px",
          marginBottom: "30px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        }}
      >
        <h2 style={{ color: "#2874a6", marginBottom: "15px" }}>
          Children’s Privacy
        </h2>
        <p>
          Our website is not intended for children under the age of 13, and we
          do not knowingly collect personal information from children. If we
          become aware that we have inadvertently collected personal information
          from a child under 13, we will take steps to delete that information
          as soon as possible.
        </p>
      </div>
      <div
        style={{
          background: "#f8f9fa",
          padding: "25px",
          borderRadius: "8px",
          marginBottom: "30px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        }}
      >
        <h2 style={{ color: "#2874a6", marginBottom: "15px" }}>
          Changes to This Privacy Policy
        </h2>
        <p>
          We may update this Privacy Policy from time to time to reflect changes
          in our practices or for other operational, legal, or regulatory
          reasons. We will post any changes to this policy on this page, and the
          "Effective Date" at the top will be updated accordingly.
        </p>
      </div>

      <div
        style={{
          background: "#f8f9fa",
          padding: "25px",
          borderRadius: "8px",
          marginBottom: "30px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        }}
      >
        <h2 style={{ color: "#2874a6", marginBottom: "15px" }}>Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy or wish to
          exercise your rights, please contact us at:
        </p>
        <p>
          Bombay Dental Company <br />
          Flat No 2 (12, Atur House, 1st Floor, 87, Dr Annie Besant Rd, Worli
          Naka, Worli, Mumbai, Maharashtra 400018 <br />
          Email:{" "}
          <a href="mailto:bombaydentalcompany@gmail.com">
            bombaydentalcompany@gmail.com{" "}
          </a>
          <br />
          Phone: <a href="tel:918882672980"> 088826 72980</a>
        </p>
      </div>
    </div>
  );
}
